<template>
  <div>
    <img id="spinner" v-if="loading" src="@img/spinner.svg"/>
    <slot v-if="!loading"></slot>
  </div>
</template>

<script>
export default {
  props: {
    loading: { required: true, type: Boolean }
  }
}
</script>

<style lang="scss" scoped>
  #spinner {
    margin: 10px auto;
    display: block;
  }
</style>